export default [
  // Stylowanie i layout
  'CSS',
  'SCSS',
  'Sass',
  'Less',
  'Stylus',

  // HTML i języki szablonów
  'HTML',
  'XML',
  'EJS',
  'Handlebars',
  'Mustache',
  'Pug',

  // Notatniki i dokumentacja
  'Jupyter Notebook',
  'Markdown',
  'reStructuredText',
  'AsciiDoc',
  'LaTeX',

  // Konfiguracja i automatyzacja
  'Makefile',
  'CMake',
  'Dockerfile',
  'Batchfile',
  'Shell',
  'INI',
  'TOML',
  'YAML',
  'JSON',
  'HCL',

  // Języki niszowe lub używane rzadko
  'QML',
  'Nix',
  'Visual Basic',
  'Objective-C',
  'Assembly',
  'COBOL',
  'Fortran',
  'Ada',
  'VHDL',
  'Verilog',
  'F#',
  'Scheme',
  'Common Lisp',
  'Crystal',
  'Elm',
  'PureScript',
  'Hack',
]
